module.exports = __webpack_public_path__ + "img/four-three.40053dee.png";